module.exports = __webpack_public_path__ + "img/BL logo - Lab Book.aa69a591.png";